import { GameStaticData } from '../StaticData/GameStaticData'

export default function gamesDetailsReducer(state = {
    games: GameStaticData,
    gamesCompletedStatus: []
}, action) {
    switch (action.type) {
        case "SET_GAME_DATA":
            return {
                ...state,
                games: action.payload
            }
        case 'SET_GAME_COMPLETED_STATUS': 
        return {
            ...state,
            gamesCompletedStatus: action.payload
        }
        default: return state
    }
}
